import { useTheme } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import type { CustomSvgIconsProps, SvgPathProps } from './CustomSvgIcons.types';

const SvgPath = ({
  iconType,
  shapeId,
  solidColor,
}: SvgPathProps): React.ReactElement => {
  if (iconType === 'bold') {
    return (
      <path
        d="M 181.820312 14.691406 C 180.8125 14.234375 156.574219 3.777344 134.320312 14.789062 C 115.75 23.976562 92.066406 49.484375 99.691406 75.191406 C 97.246094 80.402344 95.421875 85.84375 94.152344 91.480469 C 92.035156 83.691406 81.707031 51.308594 54.535156 39.222656 C 23.585938 25.476562 2.800781 43.035156 1.953125 43.785156 C 0.554688 44.988281 -0.03125 46.878906 0.421875 48.671875 C 0.585938 49.257812 15.441406 104.769531 74.800781 104.769531 C 78.351562 104.769531 82.066406 104.574219 85.976562 104.152344 C 86.105469 104.152344 86.203125 104.085938 86.332031 104.085938 C 88.582031 107.964844 90.273438 112.101562 91.15625 116.402344 C 88.449219 150.445312 90.046875 178.496094 90.046875 178.824219 C 90.210938 181.429688 92.359375 183.417969 94.933594 183.417969 C 95.03125 183.417969 95.128906 183.417969 95.226562 183.417969 C 97.929688 183.253906 99.984375 180.941406 99.820312 178.234375 C 99.820312 177.878906 97.703125 140.769531 102.558594 100.4375 C 103.242188 94.800781 104.578125 89.425781 106.566406 84.214844 C 106.695312 84.214844 106.824219 84.28125 106.988281 84.28125 C 107.117188 84.28125 107.25 84.28125 107.378906 84.28125 C 108.160156 84.214844 186.839844 77.601562 184.820312 18.925781 C 184.753906 17.070312 183.613281 15.375 181.917969 14.625 Z M 10.882812 49.421875 C 16.453125 45.96875 30.949219 39.417969 50.59375 48.148438 C 65.875 54.925781 75.09375 70.042969 80.109375 81.378906 C 64.375 66.71875 45.511719 58.117188 44.242188 57.566406 C 41.796875 56.457031 38.898438 57.566406 37.792969 60.039062 C 36.683594 62.515625 37.792969 65.382812 40.265625 66.492188 C 40.59375 66.652344 64.503906 77.535156 79.621094 94.898438 C 31.375 97.507812 14.789062 60.691406 10.882812 49.421875 Z M 111.417969 74.050781 C 119.171875 60.757812 131.746094 48.964844 149.40625 38.441406 C 151.71875 37.074219 152.46875 34.042969 151.101562 31.730469 C 149.730469 29.417969 146.703125 28.667969 144.386719 30.035156 C 128.816406 39.320312 116.828125 49.617188 108.292969 61.019531 C 110.667969 44.140625 127.644531 28.992188 138.6875 23.519531 C 144.714844 20.554688 151.035156 19.546875 156.800781 19.546875 C 164.554688 19.546875 171.332031 21.335938 174.980469 22.542969 C 173.871094 62.0625 126.894531 71.867188 111.386719 74.015625 Z M 111.417969 74.050781 "
        id={shapeId}
        fill={solidColor ? 'currentColor' : 'white'}
        fillRule="nonzero"
        fillOpacity="1"
        stroke={solidColor ? 'currentColor' : ''}
        strokeOpacity={1}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  } else if (iconType === 'normal') {
    return (
      <path
        d="M 181.820312 14.691406 C 180.8125 14.234375 156.574219 3.777344 134.320312 14.789062 C 115.75 23.976562 92.066406 49.484375 99.691406 75.191406 C 97.246094 80.402344 95.421875 85.84375 94.152344 91.480469 C 92.035156 83.691406 81.707031 51.308594 54.535156 39.222656 C 23.585938 25.476562 2.800781 43.035156 1.953125 43.785156 C 0.554688 44.988281 -0.03125 46.878906 0.421875 48.671875 C 0.585938 49.257812 15.441406 104.769531 74.800781 104.769531 C 78.351562 104.769531 82.066406 104.574219 85.976562 104.152344 C 86.105469 104.152344 86.203125 104.085938 86.332031 104.085938 C 88.582031 107.964844 90.273438 112.101562 91.15625 116.402344 C 88.449219 150.445312 90.046875 178.496094 90.046875 178.824219 C 90.210938 181.429688 92.359375 183.417969 94.933594 183.417969 C 95.03125 183.417969 95.128906 183.417969 95.226562 183.417969 C 97.929688 183.253906 99.984375 180.941406 99.820312 178.234375 C 99.820312 177.878906 97.703125 140.769531 102.558594 100.4375 C 103.242188 94.800781 104.578125 89.425781 106.566406 84.214844 C 106.695312 84.214844 106.824219 84.28125 106.988281 84.28125 C 107.117188 84.28125 107.25 84.28125 107.378906 84.28125 C 108.160156 84.214844 186.839844 77.601562 184.820312 18.925781 C 184.753906 17.070312 183.613281 15.375 181.917969 14.625 Z M 10.882812 49.421875 C 16.453125 45.96875 30.949219 39.417969 50.59375 48.148438 C 65.875 54.925781 75.09375 70.042969 80.109375 81.378906 C 64.375 66.71875 45.511719 58.117188 44.242188 57.566406 C 41.796875 56.457031 38.898438 57.566406 37.792969 60.039062 C 36.683594 62.515625 37.792969 65.382812 40.265625 66.492188 C 40.59375 66.652344 64.503906 77.535156 79.621094 94.898438 C 31.375 97.507812 14.789062 60.691406 10.882812 49.421875 Z M 111.417969 74.050781 C 119.171875 60.757812 131.746094 48.964844 149.40625 38.441406 C 151.71875 37.074219 152.46875 34.042969 151.101562 31.730469 C 149.730469 29.417969 146.703125 28.667969 144.386719 30.035156 C 128.816406 39.320312 116.828125 49.617188 108.292969 61.019531 C 110.667969 44.140625 127.644531 28.992188 138.6875 23.519531 C 144.714844 20.554688 151.035156 19.546875 156.800781 19.546875 C 164.554688 19.546875 171.332031 21.335938 174.980469 22.542969 C 173.871094 62.0625 126.894531 71.867188 111.386719 74.015625 Z M 111.417969 74.050781 "
        id={shapeId}
        fill={solidColor ? 'currentColor' : 'white'}
        fillRule="nonzero"
        fillOpacity="1"
        strokeOpacity={1}
        strokeWidth="1.1"
        stroke={solidColor ? 'currentColor' : ''}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  } else {
    return (
      <path
        d="M 181.820312 14.691406 C 180.8125 14.234375 156.574219 3.777344 134.320312 14.789062 C 115.75 23.976562 92.066406 49.484375 99.691406 75.191406 C 97.246094 80.402344 95.421875 85.84375 94.152344 91.480469 C 92.035156 83.691406 81.707031 51.308594 54.535156 39.222656 C 23.585938 25.476562 2.800781 43.035156 1.953125 43.785156 C 0.554688 44.988281 -0.03125 46.878906 0.421875 48.671875 C 0.585938 49.257812 15.441406 104.769531 74.800781 104.769531 C 78.351562 104.769531 82.066406 104.574219 85.976562 104.152344 C 86.105469 104.152344 86.203125 104.085938 86.332031 104.085938 C 88.582031 107.964844 90.273438 112.101562 91.15625 116.402344 C 88.449219 150.445312 90.046875 178.496094 90.046875 178.824219 C 90.210938 181.429688 92.359375 183.417969 94.933594 183.417969 C 95.03125 183.417969 95.128906 183.417969 95.226562 183.417969 C 97.929688 183.253906 99.984375 180.941406 99.820312 178.234375 C 99.820312 177.878906 97.703125 140.769531 102.558594 100.4375 C 103.242188 94.800781 104.578125 89.425781 106.566406 84.214844 C 106.695312 84.214844 106.824219 84.28125 106.988281 84.28125 C 107.117188 84.28125 107.25 84.28125 107.378906 84.28125 C 108.160156 84.214844 186.839844 77.601562 184.820312 18.925781 C 184.753906 17.070312 183.613281 15.375 181.917969 14.625 Z M 10.882812 49.421875 C 16.453125 45.96875 30.949219 39.417969 50.59375 48.148438 C 65.875 54.925781 75.09375 70.042969 80.109375 81.378906 C 64.375 66.71875 45.511719 58.117188 44.242188 57.566406 C 41.796875 56.457031 38.898438 57.566406 37.792969 60.039062 C 36.683594 62.515625 37.792969 65.382812 40.265625 66.492188 C 40.59375 66.652344 64.503906 77.535156 79.621094 94.898438 C 31.375 97.507812 14.789062 60.691406 10.882812 49.421875 Z M 111.417969 74.050781 C 119.171875 60.757812 131.746094 48.964844 149.40625 38.441406 C 151.71875 37.074219 152.46875 34.042969 151.101562 31.730469 C 149.730469 29.417969 146.703125 28.667969 144.386719 30.035156 C 128.816406 39.320312 116.828125 49.617188 108.292969 61.019531 C 110.667969 44.140625 127.644531 28.992188 138.6875 23.519531 C 144.714844 20.554688 151.035156 19.546875 156.800781 19.546875 C 164.554688 19.546875 171.332031 21.335938 174.980469 22.542969 C 173.871094 62.0625 126.894531 71.867188 111.386719 74.015625 Z M 111.417969 74.050781 "
        id={shapeId}
        fill={solidColor ? 'currentColor' : 'white'}
        fillRule="nonzero"
        fillOpacity="1"
        strokeOpacity={1}
        strokeWidth="1.4"
        stroke={solidColor ? 'currentColor' : ''}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    );
  }
};

export const WorkLifeBalanceIcon = ({
  shouldbegradient,
  transitionduration = 0.4,
  prefix,
  solidColor,
  iconType = 'normal',
  gradientColor,
  ...props
}: CustomSvgIconsProps): React.ReactElement => {
  const currColorId = `${prefix}_workLifeBalanceCurrentColorGradient`;
  const newColorId = `${prefix}_workLifeBalanceNewColorGradient`;
  const shapeId = `${prefix}_workLifeBalanceShape`;
  const theme = useTheme();
  const isLight = theme.palette.type === 'light';
  const colorsDark = {
    base: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.greyColors?.PLUS_8,
      stop: theme.palette.tealColors?.PLUS_2,
    },
  };
  const colorsLight = {
    base: {
      start: theme.palette?.greyColors?.PLUS_4,
      stop: theme.palette.greyColors?.PLUS_2,
    },
    hover: {
      start: theme.palette?.tealColors?.PLUS_3,
      stop: theme.palette.tealColors?.PLUS_2,
    },
  };
  const svgColors = isLight ? colorsLight : colorsDark;
  return (
    <SvgIcon {...props} viewBox={'-30 -30 250 250'}>
      {solidColor ? (
        <SvgPath
          shapeId={shapeId}
          iconType={iconType}
          solidColor={solidColor}
        />
      ) : (
        <>
          <defs>
            <linearGradient
              style={{
                transition: `${transitionduration}s`,
              }}
              id={currColorId}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%">
              <stop offset="0" stopColor={svgColors.base.start} />
              <stop offset="1" stopColor={svgColors.base.stop} />
            </linearGradient>
            <linearGradient id={newColorId} x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0" stopColor={svgColors.hover.start} />
              <stop offset="1" stopColor={svgColors.hover.stop} />
            </linearGradient>
          </defs>

          <g
            style={{
              stroke: `url("#${currColorId}")`,
            }}>
            <SvgPath
              shapeId={shapeId}
              iconType={iconType}
              solidColor={solidColor}
            />
          </g>
          <use
            xlinkHref={`#${shapeId}`}
            style={{
              stroke: `url("#${newColorId}")`,
              transition: `${transitionduration}s`,
              opacity: shouldbegradient ? 1 : 0,
            }}
          />
        </>
      )}
    </SvgIcon>
  );
};
